import styles from './starRating.less'; export {styles};

interface StarRatingStyles {
    starRating?: string;
    starIcon?: string;
    starIconActive?: string;
}

interface StarRatingProps {
    size?: 30;
    stars?: number;
    maxStars?: number;
    onChange?: (star: number) => void;
    styles?: StarRatingStyles;
}

interface StarRatingState {
    stars?: number;
    hoverStars?: number;
}

export default class StarRating extends React.PureComponent<StarRatingProps, StarRatingState> {

    constructor(props) {
        super(props);

        this.state = {stars: this.props.stars};

        this.onStarClick = this.onStarClick.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stars !== this.props.stars) {
            this.setState({...this.state,
                stars: this.props.stars,
            });
        }
    }

    onStarClick(star: number) {
        this.setState({...this.state,
            stars: star,
        }, () => {
            this.props.onChange?.(this.state.stars);
        });
    }

    onMouseEnter(star: number) {
        this.setState({...this.state,
            hoverStars: star,
        });
    }

    onMouseLeave() {
        this.setState({...this.state,
            hoverStars: undefined,
        });
    }

    render() {
        const {size = 30} = this.props;
        const {stars = 0} = this.state;
        const {maxStars = 5} = this.props;

        const activeStars = this.state.hoverStars ? this.state.hoverStars : stars;

        return (
            <div className={classNames(styles.starRating, this.props.styles?.starRating, styles['size-' + size])} onMouseLeave={this.onMouseLeave}>
                {[...Array(maxStars)].map((x, i) =>
                    <i
                        key={i}
                        className={classNames(
                            i < activeStars ? classNames('fas', styles.starIconActive, this.props.styles?.starIconActive) : 'far',
                            'fa-star',
                            styles.starIcon,
                            this.props.styles?.starIcon,
                        )}
                        onClick={() => this.onStarClick(i + 1)}
                        onMouseEnter={() => this.onMouseEnter(i + 1)}
                    />
                )}
            </div>
        );
    }
}
